export const initialValues = {
  title: '',
  displayOptions: {
    layout: 'standard',
    showFacetsCount: false,
    stickyNavigation: false,
    hideCategoryLabel: false,
    itemsPerPage: 12,
  },
  compactMode: {
    dropdownLabel: '',
    cta: {
      text: '',
      url: '',
    }
  },
  openSearchProviders: [],
};

export const openSearchProviderDetails = {
  provider: 'opensearch',
  id: '',
  indexes: '',
  filters: '',
  aggregation: '',
  sorting: [],
  facets: [],
};

export const openSearchSortingDefaults = {
  label: '',
  field: '',
  direction: '',
};

export const openSearchFacetDefaults = {
  id: '',
  field: '',
  label: '',
  hidden: false
};

export const cardViewModeDefaults = {
  id: '',
  imagePadding: false,
  clickableCard: false,
  truncatePretitle: false,
  mapping: {
    featured: '',
    badges: '',
    imageURL: '',
    pretitle: '',
    title: '',
    subtitle: '',
    body: '',
    links: '',
  },
};
